module.exports = __webpack_public_path__ + "img/yljk-active-active.df4d5732.svg";